import { create } from 'zustand';
import { ITokenInfo } from '@/request/token/token.response.interface';
import { IChainTradeSetting, ITradeState } from './interface';
import { persist } from 'zustand/middleware';
import { KlinePeriodTime } from '../components/LightweightCharts/config';
export const useTradeStore = create<ITradeState>()(
  persist(
    (set) => ({
      tokenInfo: null,
      tokenAddress: '',
      chainTokenAmount: '0',
      tokenRealtimePrice: '0',
      priceChg: '0',
      solTradeSetting: { slippage: '5', fee: '0.018', feeAuto: true, slippageAuto: true, antiMevOpen: true },
      bscTradeSetting: { slippage: '5', fee: '0.1', feeAuto: true, slippageAuto: true, antiMevOpen: true },
      klinePeriod: '5m',
      setTokenInfo: (tokenInfo: ITokenInfo | null) => set({ tokenInfo }),
      setTokenAddress: (tokenAddress: string) => set({ tokenAddress }),
      setChainTokenAmount: (chainTokenAmount: number | string) => set({ chainTokenAmount }),
      setTokenRealtimePrice: (tokenRealtimePrice: string) => set({ tokenRealtimePrice }),
      setPriceChg: (priceChg: string) => set({ priceChg }),
      setKlinePeriod: (klinePeriod: KlinePeriodTime) => set({ klinePeriod }),
      setBscTradeSetting: (bscTradeSetting: IChainTradeSetting) => set({ bscTradeSetting }),
      setSolTradeSetting: (solTradeSetting: IChainTradeSetting) => set({ solTradeSetting }),
    }),
    {
      name: 'trade_store',
      partialize: (state) => ({
        bscTradeSetting: state.bscTradeSetting,
        solTradeSetting: state.solTradeSetting,
        klinePeriod: state.klinePeriod,
      }),
    },
  ),
);
